import { render } from "./SejongHeader.vue?vue&type=template&id=fbd01d6c"
import script from "./SejongHeader.vue?vue&type=script&lang=js"
export * from "./SejongHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__